import React, { forwardRef } from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'

import styles from './round-checkbox.css'

const RoundCheckbox = forwardRef(({
  label,
  checked,
  onChange,
  onBlur,
  disabled,
  name,
  className = '',
  ...rest
}, ref) => (
  <label className={classNames(styles.container, disabled && styles.disabled, className)}>
    <input
      ref={ref}
      type="checkbox"
      name={name}
      checked={checked}
      onChange={onChange}
      onBlur={onBlur}
      disabled={disabled}
      className={styles.input}
      {...rest}
    />

    <span className={classNames(styles.indicator, checked && styles.checked)} />
    <span className={styles.label}>{label}</span>
  </label>
))

RoundCheckbox.propTypes = {
  label: PropTypes.node.isRequired,
  checked: PropTypes.bool,
  onChange: PropTypes.func,
  onBlur: PropTypes.func,
  disabled: PropTypes.bool,
  name: PropTypes.string.isRequired,
  className: PropTypes.string
}

RoundCheckbox.defaultProps = {
  checked: false,
  onChange: undefined,
  onBlur: undefined,
  disabled: false,
  className: ''
}

export default RoundCheckbox
